import { HomePage } from "./pages/HomePage";
import { ApplicationPage, ApplicationDetailPage } from "./pages/ApplicationPage";
import { CategoryPage } from "./pages/CategoryPage";
import { TranslationPage } from "./pages/TranslationPage";
import { ImagePage } from "./pages/ImagePage";
import { ReviewPage } from "./pages/ReviewPage";
import { Role } from "./infrastructure/Constants";


const AppRoutes = [
  {
        index: true,
        role: Role.Professional,
        element: <HomePage />
    },
    {
        path: '/Applications',
        role: Role.Professional,
        element: <ApplicationPage />
    },
    {
        path: '/applications/:applicationKey',
        role: Role.Professional,
        element: <ApplicationDetailPage />
    },
    {
        path: '/Categories',
        role: Role.Professional,
        element: <CategoryPage />
    },
    {
        path: '/applications/:applicationKey/translations',
        role: Role.Professional,
        element: <TranslationPage />
    },
    {
        path: '/applications/:applicationKey/target/:target/translations',
        role: Role.Professional,
        element: <TranslationPage />
    },
    {
        path: '/applications/:applicationKey/source/:source/translations',
        role: Role.Professional,
        element: <TranslationPage />
    },
    {
        path: '/applications/:applicationKey/source/:source/target/:target/translations',
        role: Role.Professional,
        element: <TranslationPage />
    },
    {
        path: '/applications/:applicationKey/source/:source/target/:target/review',
        role: Role.Novice,
        element: <ReviewPage />
    },
    {
        path: '/applications/:applicationKey/source/:source/images',
        role: Role.Professional,
        element: <ImagePage />
    },
];

export default AppRoutes;
